import { useThrottleFn } from '@vueuse/core'

const ONE_FRAME_MS = 1000 / 60 // 60th of a second in ms

export function useThrottleFrame(fn: () => void) {
  return useThrottleFn(fn, ONE_FRAME_MS, true)
}
